import { call, put, takeLatest, select } from "redux-saga/effects";
import { PROYECT, api_get } from "../../services/api";
import { getNumberHours } from "../../helpers/parseDates";
import {
  orderedGraphTimeAxes,
  orderedGraphTimeDayAxes,
} from "../../helpers/getOrdersGraph";
import {
  getStations,
  orderCompaniesAndStations,
} from "../../helpers/companiesNormalized";

const LOAD_DATA_ORDERS_GRAPH = "LOAD_DATA_ORDERS_GRAPH";
const SET_DATA_ORDERS_GRAPH = "SET_DATA_ORDERS_GRAPH";
const ERROR_DATA_ORDERS_GRAPH = "ERROR_DATA_ORDERS_GRAPH";

const LOAD_UNITS_ORDERS_GRAPH = "LOAD_UNITS_ORDERS_GRAPH";
const SET_UNITS_ORDERS_GRAPH = "SET_UNITS_ORDERS_GRAPH";
const ERROR_UNITS_ORDERS_GRAPH = "ERROR_UNITS_ORDERS_GRAPH";

const CHANGE_COMPANY_ORDERS_GRAPH = "CHANGE_COMPANY_ORDERS_GRAPH";
const CHANGE_STATION_ORDERS_GRAPH = "CHANGE_STATION_ORDERS_GRAPH";

const CLEAR_ORDERS_GRAPH = "CLEAR_DATA_ORDERS_GRAPH";
const CLEAR_ERROR_ORDERS_GRAPH = "CLEAR_ERROR_ORDERS_GRAPH";
const SET_ERROR_ORDERS_GRAPH = "SET_ERROR_ORDERS_GRAPH";

const INITIAL_STATE = {
  units: [],
  isLoading: false,
  error: false,
  message: "",
  errorMessage: "",
  unitsTimeAxeX: [],
  unitsTimeAxeY: [],
  unitsTimeDayAxeX: [],
  unitsTimeDayAxeY: [],
  companies: [],
  stations: [],
  isLoadingFilters: false,
  companySelected: "",
  stationSelected: "",
  companyStations: [],
};

const ordersGraphReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case LOAD_DATA_ORDERS_GRAPH:
      return {
        ...state,
        companies: [],
        stations: [],
        isLoadingFilters: true,
        error: false,
        errorMessage: "",
      };
    case SET_DATA_ORDERS_GRAPH:
      return {
        ...state,
        companies: payload.companies,
        stations: payload.stations,
        isLoadingFilters: false,
      };
    case ERROR_DATA_ORDERS_GRAPH:
      return {
        ...state,
        isLoadingfilters: false,
        error: true,
        errorMessage: payload.message,
      };
    case LOAD_UNITS_ORDERS_GRAPH:
      return {
        ...state,
        units: [],
        isLoading: true,
        error: false,
        message: "",
        errorMessage: "",
      };
    case SET_UNITS_ORDERS_GRAPH:
      return {
        ...state,
        units: payload.units,
        unitsTimeAxeX: payload.unitsTimeAxeX,
        unitsTimeDayAxeX: payload.unitsTimeDayAxeX,
        unitsTimeAxeY: payload.unitsTimeAxeY,
        unitsTimeDayAxeY: payload.unitsTimeDayAxeY,
        isLoading: false,
      };
    case ERROR_UNITS_ORDERS_GRAPH:
      return {
        ...state,
        isLoading: false,
        error: true,
        errorMessage: payload.message,
      };
    case CHANGE_COMPANY_ORDERS_GRAPH:
      return {
        ...state,
        companySelected: payload.company,
        companyStations: payload.stations,
      };
    case CHANGE_STATION_ORDERS_GRAPH:
      return {
        ...state,
        stationSelected: payload,
      };
    case CLEAR_ORDERS_GRAPH:
      return {
        ...state,
        ...INITIAL_STATE,
      };
    case CLEAR_ERROR_ORDERS_GRAPH:
      return {
        ...state,
        error: false,
        errorMessage: "",
      };
    case SET_ERROR_ORDERS_GRAPH:
      return {
        ...state,
        error: true,
        errorMessage: payload,
      };
    default:
      return state;
  }
};

function getData() {
  return {
    type: LOAD_DATA_ORDERS_GRAPH,
  };
}

function getUnits(stations) {
  return {
    type: LOAD_UNITS_ORDERS_GRAPH,
    payload: {
      stations,
    },
  };
}

function changeCompany(company, stations) {
  return {
    type: CHANGE_COMPANY_ORDERS_GRAPH,
    payload: { company, stations },
  };
}

function changeStation(station) {
  return {
    type: CHANGE_STATION_ORDERS_GRAPH,
    payload: station,
  };
}

function clearError() {
  return {
    type: CLEAR_ERROR_ORDERS_GRAPH,
  };
}

function* fetchData() {
  const token = yield select((state) => state.login.token);
  const auth = { headers: { authorization: `${token}` } };
  const urlCompanies = `${process.env.REACT_APP_URL}${PROYECT}/companies`;
  try {
    const companies = yield call(api_get, urlCompanies, auth);
    const stations = getStations(companies.companies);
    const orderedCompanies = orderCompaniesAndStations(companies.companies);

    yield put({
      type: SET_DATA_ORDERS_GRAPH,
      payload: {
        companies: orderedCompanies,
        stations,
      },
    });
  } catch (message) {
    yield put({
      type: ERROR_DATA_ORDERS_GRAPH,
      payload: {
        message,
      },
    });
  }
}

function* fetchUnits(action) {
  const {
    payload: { stations = [] },
  } = action;
  const token = yield select((state) => state.login.token);
  const auth = { headers: { authorization: `${token}` } };
  const baseUrl = `${process.env.REACT_APP_URL}${PROYECT}/stats/stations/services/times?`;
  let urlStations = "";

  if (stations) {
    stations.forEach((station) => {
      urlStations = `${urlStations}&stations=${station.value}`;
    });
  }

  const url = `${baseUrl}${urlStations}`;

  try {
    const response = yield call(api_get, url, auth);

    let stationCall = {};
    let normalizedUnits = {};
    const units = [];

    // eslint-disable-next-line
    for (const key of Object.keys(response)) {
      stationCall = { ...response[key] };
    }
    // eslint-disable-next-line
    for (const key of Object.keys(stationCall)) {
      const hist_average = getNumberHours(stationCall[key].hist_average);
      const day_average = getNumberHours(stationCall[key].day_average);
      stationCall[key].hist_number = hist_average;
      stationCall[key].day_number = day_average;
      stationCall[key].hist_services =
        Math.round(hist_average * stationCall[key].services * 100) / 100;
      units.push(stationCall[key]);
      normalizedUnits = {
        ...normalizedUnits,
        [stationCall[key].number]: stationCall[key],
      };
    }

    const { axeX, axeY } = orderedGraphTimeAxes(units, "hist_services", [
      8, 7, 5, 0,
    ]);
    const { axeX: axeXDay, axeY: axeYDay } = orderedGraphTimeDayAxes(
      units,
      "day_number",
      [1.5, 1, 0.5, 0]
    );

    yield put({
      type: SET_UNITS_ORDERS_GRAPH,
      payload: {
        units: normalizedUnits,
        unitsTimeAxeX: axeX,
        unitsTimeDayAxeX: axeXDay,
        unitsTimeAxeY: axeY,
        unitsTimeDayAxeY: axeYDay,
      },
    });
  } catch (message) {
    yield put({
      type: ERROR_UNITS_ORDERS_GRAPH,
      payload: {
        message,
      },
    });
  }
}

function* ordersGraphSaga() {
  yield takeLatest(LOAD_DATA_ORDERS_GRAPH, fetchData);
  yield takeLatest(LOAD_UNITS_ORDERS_GRAPH, fetchUnits);
}

export {
  ordersGraphReducer,
  getData,
  getUnits,
  changeCompany,
  changeStation,
  clearError,
  ordersGraphSaga,
};
